module.exports = __webpack_public_path__ + "static/media/c1.6e349383.jpg";